import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gap: '4rem',
    gridTemplateColumns: 'auto 1fr',
    height: 'calc(100svh - 200px)',
    backgroundImage: 'url(/imgs/BG.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    borderRadius: '1rem',
    padding: '0px 2.5rem',
    overflowX: 'auto',
    zIndex: 1,
    position: 'relative',
    [theme.breakpoints.down('xl')]: {
      gap: '2rem',
      padding: '0px 1rem'
    },
    [theme.breakpoints.down('sm')]: {
      height: '65svh',
      gridTemplateColumns: 'auto',
      gridTemplateRows: 'auto auto'
    }
  },

  cardBottom: {
    backgroundColor: '#fff',
    borderBottomLeftRadius: '0.75rem',
    borderBottomRightRadius: '0.75rem',
    fontSize: theme.size.sm,
    padding: '0px 16px 16px 16px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
      borderTopLeftRadius: '0.75rem',
      borderTopRightRadius: '0.75rem'
    }
  },

  alignCenter: {
    textAlign: 'center'
  },

  cardBottomRow: {
    fontSize: theme.size.sm,
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    cursor: 'pointer',
    padding: ' 0.35rem 0px'
  },

  activeCardBottomRow: {
    color: theme.palette.primary.main
  },

  header: {
    marginTop: '4.5rem',
    marginBottom: '2.5rem',
    fontSize: theme.size.xxl,
    fontWeight: 600,
    color: '#fff',
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      marginTop: '0.75rem',
      marginBottom: '1rem'
    }
  },

  subHeader: {
    marginTop: '0',
    marginBottom: '2.5rem',
    fontSize: theme.size.xxl,
    fontWeight: 600,
    color: '#fff',
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      marginBottom: '1rem'
    }
  },

  sectionHeader: {
    fontSize: theme.size.xl,
    fontWeight: 600,
    color: '#fff',
    position: 'relative',
    zIndex: 2,
    margin: '1rem 0'
  },

  dataContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
    gridGap: '1rem',
    overflowY: 'auto',
    paddingBottom: '2rem',
    alignItems: 'baseline',
    [theme.breakpoints.down(1522)]: {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))'
    },
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
    },
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
    }
  },

  fade: {
    backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0))',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '20rem'
  },

  contactBackground: {
    backgroundColor: '#fff',
    borderRadius: '0.75rem'
  },

  myProfileCard: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },

  favoriteRow: {
    backgroundColor: '#fff',
    borderRadius: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: theme.size.sm,
    marginBottom: '1rem',
    padding: '0.5rem',
    gap: '1rem'
  },

  chipRoot: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
    marginBottom: '1rem',
    alignItems: 'center'
  },

  searchInput: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
